export default "__VITE_PUBLIC_ASSET__ac87efca__"